<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";

  import type { Tab } from "@shared/types/Tab";

  const dispatch = createEventDispatcher();

  const { trackClick } = EventTracking;

  export let tabs: Tab[];
  export let active: number = 0;
  export let trackingHelper = null;

  let currentTab: Tab;

  $: {
    currentTab = tabs[active];
  }

  $: currentParms = currentTab?.params || {};

  const handleClick = (index, tabId) => {
    active = index;
    dispatch("click", tabs[index]);
    if (trackingHelper) {
      const { trackingEntity, targetObject } = trackingHelper(tabId);
      trackClick(targetObject, trackingEntity);
    }
  };
</script>

<ul class="fizz-tab-list">
  {#each tabs as tab, index}
    <li
      id={tab.id}
      data-testid={tab.id}
      class={active === index ? "fizz-is-active" : ""}
      disabled={tab.isDisabled}
      on:click={() => handleClick(index, tab.id)}
    >
      {tab.title}
    </li>
  {/each}
</ul>

{#if currentTab?.component}
  <svelte:component this={currentTab.component} {...currentParms} />
{/if}
